/* src/app/features/produtos-permitidos/modal-produtos-permitidos.component.scss */
.alert {
  margin-top: 1em !important;
}
/*# sourceMappingURL=modal-produtos-permitidos.component.css.map */
